"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeTokenExpiry = exports.generateTokenExpiry = void 0;
const luxon_1 = require("luxon");
/**
 * Set expiry to be at least `minDays` in the future, and to fall on a Sunday at 3am NY timezone.
 */
const generateTokenExpiry = (externalNow = luxon_1.DateTime.now(), minDays = 7) => {
    // Use NY timezone for calculations
    const now = externalNow.setZone('America/New_York');
    const expiry = now
        // Move forward at least `minimumExpiryDays`
        .plus({ days: minDays })
        // If not already on a Sunday (7=Sunday), move forward to next Sunday
        .plus({ days: 7 - now.weekday })
        // 3am
        .set({ hour: 3, minute: 0, second: 0 });
    return {
        // Need a JS date when setting cookie expiry
        expiryDate: luxon_1.DateTime.fromJSDate(expiry.toJSDate()),
        // Need seconds until expiration when setting JWT expiry
        expireInSeconds: Math.floor(expiry.diff(now).milliseconds / 1000),
    };
};
exports.generateTokenExpiry = generateTokenExpiry;
/**
 * Decode auth token's expiry DateTime. Not importing the `decoded` type from `jsonwebtoken` because
 * don't want that as a `common` dependency, and this partial type signature is all we need.
 */
const decodeTokenExpiry = (decoded) => {
    if (typeof decoded === 'object' && typeof decoded?.exp === 'number') {
        return luxon_1.DateTime.fromMillis(decoded.exp * 1000);
    }
    return null;
};
exports.decodeTokenExpiry = decodeTokenExpiry;
//# sourceMappingURL=tokens.js.map